import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const containerStyles = xcss({
	display: 'flex',
	gap: 'space.100',
	paddingTop: 'space.100',
});

const filterStyles = xcss({
	backgroundColor: 'color.background.accent.gray.subtlest',
	borderRadius: 'radius.small',
	height: 'size.300',
	width: 'size.600',
});

export const LoadingFilters = (): React.JSX.Element => {
	return (
		<Box xcss={containerStyles}>
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
			<Box xcss={filterStyles} />
		</Box>
	);
};
